import { render, staticRenderFns } from "./ComponentUpdateModal.vue?vue&type=template&id=3b324784&scoped=true&"
import script from "./ComponentUpdateModal.vue?vue&type=script&lang=js&"
export * from "./ComponentUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./ComponentUpdateModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ComponentUpdateModal.vue?vue&type=style&index=1&id=3b324784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b324784",
  null
  
)

export default component.exports